export default {
  labels: {
    invoice: 'Faktura',
    on_site: 'Płatność na miejscu (gotówka/karta)',
  },
};
